import { AnimatePresence, motion } from "framer-motion";
import { forwardRef, useState } from "react";
import { wrap } from "framer-motion";

/* ================= Assets ================= */
import jp from "./images/jobportal website.png";
import p from "./images/tm.png";
import ls from "./images/loan.png";
import wbap from "./images/lotus web app.png";
import book from "./images/bookhaven.png";
import { Link } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

/* ================= Data ================= */

const slides = [
  {
    image: ls,
    headline: "Loan Management & Tracking System",
    paragraph:
      "A complete microloan management platform where users can apply online, track loan status, and admins can approve, reject, and manage repayments using role-based dashboards.",
  },
  {
    image: jp,
    headline: "Job Portal",
    paragraph:
      "A full-stack job portal where users apply for jobs and employers manage listings. Built with React, Node.js, Express, and MongoDB.",
  },
  {
    image: book,
    headline: "The Book Haven Universe",
    paragraph:
      "A cozy digital platform for book lovers featuring curated reviews, recommendations, and thoughtful insights across genres.",
  },
  {
    image: wbap,
    headline: "Lotus Game Web App",
    paragraph:
      "A gaming discovery platform where users explore, rate, and browse games by category using modern React and Firebase tech.",
  },
  {
    image: p,
    headline: "Task Management Web App",
    paragraph:
      "A simple yet effective task management app to organize, track, and manage daily work efficiently.",
  },
];

/* ================= Component ================= */

export default function PresenceSlider() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const paginate = (newDirection) => {
    setIndex((prev) => wrap(0, slides.length, prev + newDirection));
    setDirection(newDirection);
  };

  return (
    <div style={container}>
      <motion.button
        style={button}
        onClick={() => paginate(-1)}
        whileTap={{ scale: 0.9 }}
      >
        <ArrowLeft />
      </motion.button>

      <div style={sliderWrapper}>
        <AnimatePresence custom={direction} initial={false} mode="wait">
          <Slide key={index} slide={slides[index]} custom={direction} />
        </AnimatePresence>
      </div>

      <motion.button
        style={button}
        onClick={() => paginate(1)}
        whileTap={{ scale: 0.9 }}
      >
        <ArrowRight />
      </motion.button>
    </div>
  );
}

/* ================= Slide ================= */

const Slide = forwardRef(({ slide, custom }, ref) => {
  return (
    <>
      {" "}
      <motion.div
        ref={ref}
        custom={custom}
        initial={(dir) => ({ opacity: 0, x: dir * 80 })}
        animate={{ opacity: 1, x: 0 }}
        exit={(dir) => ({ opacity: 0, x: dir * -80 })}
        transition={{ type: "spring", bounce: 0.3 }}
        style={card}
      >
        <img src={slide.image} alt={slide.headline} style={image} />

        <h2>{slide.headline}</h2>
        <p>{slide.paragraph}</p>
      </motion.div>
      <div>
        <Link
          to="/projects"
          className="inline-flex items-center mt-6 text-lg font-bold text-lime-400 group transition-all  hover:font-extrabold hover:text-2xl"
        >
          See Projects
          <FontAwesomeIcon
            icon={faArrowRight}
            className="ml-3 group-hover:ml-5 transition-all"
          />
        </Link>
      </div>
    </>
  );
});

/* ================= Icons ================= */

function ArrowLeft() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </svg>
  );
}

function ArrowRight() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  );
}

/* ================= Styles ================= */

const container = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 20,
};

const sliderWrapper = {
  width: 800,
  height: 600,
  overflow: "hidden",
};

const card = {
 
  borderRadius: 16,
  padding: 20,
  textAlign: "center",
  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
};

const image = {
  width: "100%",
  height: 220,
  objectFit: "cover",
  borderRadius: 12,
  marginBottom: 15,
};

const button = {
  width: 60,
  height: 60,
  borderRadius: "50%",
  border: "none",
  background: "#111",
  color: "#fff",
  cursor: "pointer",
};
